import { State } from '../../types';

export const missouri: State = {
  name: 'Missouri',
  abbreviation: 'MO',
  terms: [
    {
      word: 'Auxvasse',
      phonetic: 'Of-aw-zzz',
      // audioUrl: '/audio/auxvasse.mp3',
      description: 'A city in Callaway County, often mispronounced due to its French origin.'
    },
    {
      word: 'Bolivar',
      phonetic: 'Ball-i-ver',
      // audioUrl: '/audio/bolivar.mp3',
      description: 'A city in Polk County, pronounced differently from the South American country.'
    },
    {
      word: 'Bona',
      phonetic: 'Bonnie',
      // audioUrl: '/audio/bona.mp3',
      description: 'An unincorporated community in Dade County, with a pronunciation that may surprise newcomers.'
    },
    {
      word: 'Carondelet',
      phonetic: 'kuh-RAHN-duh-let',
      audioUrl: '/audio/carondelet.mp3',
      description: 'Historic neighborhood in St. Louis'
    },
    {
      word: 'Hayti',
      phonetic: 'Hay-Tie',
      // audioUrl: '/audio/hayti.mp3',
      description: 'A city in Pemiscot County, pronounced differently from the Caribbean nation.'
    },
    {
      word: 'Kearney',
      phonetic: 'Car-knee',
      // audioUrl: '/audio/kearney.mp3',
      description: 'A city in Clay County, with a pronunciation that may not be intuitive.'
    },
    {
      word: 'Lebanon',
      phonetic: 'Lebuh-nun',
      // audioUrl: '/audio/lebanon.mp3',
      description: 'A city in Laclede County, pronounced differently from the Middle Eastern country.'
    },
    {
      word: 'Nevada',
      phonetic: 'Ne-VAY-duh',
      // audioUrl: '/audio/nevada.mp3',
      description: 'A city in Vernon County, pronounced differently from the western state.'
    },
    {
      word: 'Versailles',
      phonetic: 'Ver-SAIL-s',
      // audioUrl: '/audio/versailles.mp3',
      description: 'A city in Morgan County, pronounced differently from the French city.'
    }
  ]
};